import { makeStyles } from "@material-ui/core";
import { Card } from "@material-ui/core";
import { CardActions } from "@material-ui/core";
import { CardContent } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import React, { Component, type MouseEventHandler } from "react";
import { Alert } from "react-bootstrap";

type GenericPanelProps = {
	title: string;
	description?: string;
	showPromptSuccess?: boolean;
	showPromptError?: boolean;
	onDismissSuccess?: MouseEventHandler;
	onDismissError?: MouseEventHandler;
	successMessage?: string;
	error?: any;
	children: any;
};

/********************MATERIAL UI STYLES********************************** */

/************************************************************************* */

const GenericPanel = ({
	title,
	description = "",
	showPromptSuccess = false,
	showPromptError = false,
	onDismissSuccess = () => null,
	onDismissError = () => null,
	successMessage,
	error,
	children,
}: GenericPanelProps) => (
	<div className="content-wrapper">
		<div className="row">
			<div className="col-lg-12">
				<Alert
					show={showPromptError}
					variant="danger"
					dismissible={true}
					onClose={onDismissError}
				>
					<strong>There was an error</strong>
					<p>
						{error === undefined
							? "There was an error"
							: error?.internalError.message === undefined
								? error?.internalError
								: error?.internalError?.message}
					</p>
				</Alert>
				<Alert
					show={showPromptSuccess}
					variant="success"
					onClose={onDismissSuccess}
				>
					<p>{successMessage || "Operation was success"}</p>
				</Alert>
			</div>
		</div>
		<h3>
			{title}
			<small>{description}</small>
		</h3>
		{children}
	</div>
);

type MasterDetailPanelProps = {
	title: string;
	onSave: MouseEventHandler;
	onCancel: MouseEventHandler;
	onDelete: MouseEventHandler;
	saveStatus: boolean;
	deleteStatus: boolean;
	showSave: boolean;
	showDelete: boolean;
};

class MasterDetailPanel extends Component<MasterDetailPanelProps> {
	useStyles() {
		return makeStyles((theme) => ({
			root: {
				"& > *": {
					margin: theme.spacing(1),
				},
				marginBottom: theme.spacing(1),
			},
		}));
	}

	render() {
		return (
			<div className="pb-2">
				<Card variant="outlined">
					<CardContent>
						<Typography gutterBottom variant="h5" component="h2">
							{this.props.title || ""}
						</Typography>
						{this.props.children}
					</CardContent>
					<CardActions className="px-3 ">
						<button
							className="btn btn-danger"
							onClick={this.props.onCancel}
							disabled={!this.props.saveStatus}
						>
							Cancel
						</button>
						{(this.props.showSave === undefined || this.props.showSave) && (
							<button
								className="btn btn-primary mes-button-primary"
								onClick={this.props.onSave}
								disabled={!this.props.saveStatus}
							>
								Save
							</button>
						)}
						{this.props.showDelete && (
							<button
								className="btn btn-primary mes-button-primary"
								onClick={this.props.onDelete}
								disabled={!this.props.deleteStatus}
							>
								Delete
							</button>
						)}
					</CardActions>
				</Card>
			</div>
		);
	}
}

type ExtraButton = {
	name: string;
	onClick: MouseEventHandler;
};

type FilterPanelProps = {
	onClickExport?: Function;
	onClickReset: Function;
	OnClickGo: Function;
	showButtons: boolean;
	showExport: boolean;
	extraButtons?: ExtraButton[];
};

class FilterPanel extends Component<FilterPanelProps> {
	public onClickGo: MouseEventHandler;
	public onClickReset: MouseEventHandler;
	public onClickExport: MouseEventHandler;

	constructor(props: FilterPanelProps) {
		super(props);
		this.state = {};
		this.onClickGo = this.GetFilterValues.bind(this);
		this.onClickReset = this.ResetFilterValues.bind(this);
		this.onClickExport = this.ExportData.bind(this);
	}

	ExportData() {
		if (this.props.onClickExport !== undefined) this.props.onClickExport();
	}

	ResetFilterValues() {
		if (this.props.onClickReset !== undefined) this.props.onClickReset();
	}

	GetFilterValues() {
		if (this.props.OnClickGo !== undefined) this.props.OnClickGo();
	}

	render() {
		const buttonList =
			this.props.extraButtons === undefined ? [] : this.props.extraButtons;
		const extraButtons = buttonList.map((button, index) => (
			<button
				type="button"
				className="btn btn-primary btn-sm mr-2"
				onClick={button.onClick}
				key={index}
			>
				{button.name}
			</button>
		));
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<div className="row">
							{this.props.children}

							<div className="me-auto">
								{!!this.props.showButtons && (
									<React.Fragment>
										<div className="pt-2">
											<button
												type="button"
												className="btn btn-primary  btn mr-2"
												onClick={this.onClickGo}
											>
												Go
											</button>
											<button
												type="button"
												className="btn btn-danger btn-sm mr-2"
												onClick={this.onClickReset}
											>
												Reset
											</button>
										</div>
									</React.Fragment>
								)}
								{extraButtons}
								{!!this.props.showExport && (
									<div className="pt-2">
										<button
											type="button"
											className="btn btn-success"
											onClick={this.onClickExport}
										>
											<i className="fa fa-download"></i>Excel
										</button>
									</div>
								)}
							</div>
						</div>
					</div>

					{/* <div className="col-md-1">                    
                        
                        <div className="btn-group ml-auto mr-0 my-auto" role="group" aria-label="Basic example">                        
                           
                        </div>                        
                    </div>    
                    }           */}
				</div>
			</div>
		);
	}
}

class LongFilterPanel extends Component<FilterPanelProps> {
	public onClickGo: MouseEventHandler;
	public onClickReset: MouseEventHandler;
	public onClickExport: MouseEventHandler;

	constructor(props: any) {
		super(props);
		this.state = {};
		this.onClickGo = this.GetFilterValues.bind(this);
		this.onClickReset = this.ResetFilterValues.bind(this);
		this.onClickExport = this.ExportData.bind(this);
	}
	ExportData() {
		if (this.props.onClickExport !== undefined) this.props.onClickExport();
	}
	ResetFilterValues() {
		if (this.props.onClickReset !== undefined) this.props.onClickReset();
	}
	GetFilterValues() {
		if (this.props.OnClickGo !== undefined) this.props.OnClickGo();
	}

	render() {
		const buttonList =
			this.props.extraButtons === undefined ? [] : this.props.extraButtons;
		const extraButtons = buttonList.map((button, index) => (
			<button
				type="button"
				className="btn btn-primary btn-sm mr-2"
				onClick={button.onClick}
				key={index}
			>
				{button.name}
			</button>
		));
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						{this.props.children}

						<div className="me-auto">
							{!!this.props.showButtons && (
								<div className="container-fluid">
									<div className="col-md-10">
										<div className="pt-2">
											<button
												type="button"
												className="btn btn-primary  btn mr-2"
												onClick={this.onClickGo}
											>
												Go
											</button>
											<button
												type="button"
												className="btn btn-danger btn-sm mr-2"
												onClick={this.onClickReset}
											>
												Reset
											</button>
											{!!this.props.showExport && (
												<button
													type="button"
													className="btn btn-success"
													onClick={this.onClickExport}
												>
													<i className="fa fa-download"></i>Excel
												</button>
											)}
											{extraButtons}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { GenericPanel, FilterPanel, MasterDetailPanel, LongFilterPanel };
